// frontend/src/pages/ContentPolicy.jsx
import React from "react";
import Screen from "../uizard/ui/Screen";

export default function ContentPolicy() {
  return (
    <Screen>
      <section style={{ maxWidth: 900 }}>
        <h1 className="h1">Content Policy</h1>
        <p className="lead">What’s allowed, and what isn’t, on ArtiBytes.</p>

        <p style={{ lineHeight: 1.6 }}>
          This policy applies to everything you create or provide on ArtiBytes —
          image generations, video animations, the prompts you write, and any
          images you upload as source material or for style training.
        </p>

        <ul style={{ lineHeight: 1.6 }}>
          <li>No illegal content or activity.</li>
          <li>No explicit adult content. Zero tolerance for any sexual content involving minors.</li>
          <li>No hate, harassment, or incitement of violence.</li>
          <li>No graphic violence or gore.</li>
          <li>No infringement: don’t upload or prompt others’ intellectual property without permission.</li>
          <li>No attempts to impersonate private individuals or create deceptive likenesses.</li>
          <li>Don’t upload images you don’t have the right to use, including as a source for animation or style training.</li>
          <li>Comply with local laws and platform terms (including Creator Program rules).</li>
        </ul>

        <p style={{ lineHeight: 1.6 }}>
          All outputs are AI-generated. You’re responsible for how you use them,
          including any disclosure required where you share or publish AI content.
        </p>

        <p style={{ color: "#6b7280" }}>
          We may review, limit, or remove content to keep the community safe and compliant.
        </p>
      </section>
    </Screen>
  );
}